// extracted by mini-css-extract-plugin
module.exports = {"root":"Section_root__3pAQr","label":"Section_label__3l5nG","contentWrap":"Section_contentWrap__22UzP","footer":"Section_footer__25Xj6","footerInner":"Section_footerInner__UrY2P"};